export const spyBarScrollIntersectionObserver = (
  root,
  settings,
  callback
) => {
  const options = {
    root,
    rootMargin: '-10% 0% -90% 0%',
  }

  const scrollObserver = new IntersectionObserver((entry) => {
    const intersectingEntry = entry?.find(
      ({ isIntersecting }) => isIntersecting === true
    )

    const id = intersectingEntry?.target?.id ?? ''

    if (intersectingEntry) {
      const currentScrolledSetting = settings?.filter(
        ({ text }) => text === id
      )[0]
      callback(currentScrolledSetting?.ref)
    }
  }, options)

  return scrollObserver
}
